import { AttrField, BooleanField, OrmModel, StringField } from 'vuex-orm-decorators'
import BaseModel from '@/data/models/BaseModel'
import { modelNames } from '@/data/models/types'

@OrmModel(modelNames.BYOC_PHONE)
export default class ByocPhone extends BaseModel {
  @StringField()
  public phone: string

  @AttrField(null)
  public label: string | null

  @BooleanField()
  public sms: boolean

  @BooleanField()
  public voice: boolean

  @BooleanField()
  public mms: boolean

  @StringField()
  public byocCarrierId: string
}
